import { jwtDecode } from 'jwt-decode';

type TParsedResponseToken = {
  email: string;
  exp: number;
  iat: number;
};

type ParsedTokenResponse = { email: string; token: string } | null;

export const parseRecoveryToken = (
  urlSearch: URLSearchParams
): ParsedTokenResponse => {
  const recoveryToken = urlSearch.get('token');

  if (recoveryToken) {
    try {
      const parsedToken = jwtDecode<TParsedResponseToken>(recoveryToken);

      if (parsedToken) {
        return {
          email: parsedToken.email,
          token: recoveryToken,
        };
      }
    } catch (error) {
      // Invalid token format
      return null;
    }
  }

  return null;
};
